import defaultState from "./state";

const main = (state = defaultState, action) => {
  switch (action.type) {
    case "NAVEGAR_POR_RUTA":
      return Object.assign({}, state, {
        ruta: action.nuevaRuta,
        parametros: action.parametros,
      });

    default:
      return state;
  }
};

export default main;
